import { ref } from '@vue/composition-api';
import { PaginationResponse } from '@/bundles/App/type';
import { IPaginationDto } from '@/bundles/App/interfaces';
import { voiceClassService } from '@/bundles/VideoContent/factory/voiceClassServiceFactory';

interface IVoiceClassDto {
  name: string;
  description: string;
  image?: File;
  instructor: string;
  video: string;
  duration: number;
  file?: any;
}

export function useVoiceClass() {
  const voiceClasses = ref<any[]>([]);
  const total = ref<number>(0);
  const loading = ref<boolean>(false);
  const error = ref<Error | null>(null);

  const fetchVoiceClasses = async (params: IPaginationDto): Promise<void> => {
    loading.value = true;
    error.value = null;

    try {
      const response: PaginationResponse<any> = await voiceClassService.getList(params);
      voiceClasses.value = response.data;
      total.value = response.total;
    } catch (e) {
      throw e;
    } finally {
      loading.value = false;
    }
  };

  const convertToFormData = (voiceClass: IVoiceClassDto): FormData => {
    const formData = new FormData();
    formData.append('name', voiceClass.name);
    formData.append('description', voiceClass.description);
    formData.append('instructor', voiceClass.instructor);
    formData.append('video', voiceClass.video);
    formData.append('duration', voiceClass.duration as unknown as string);
    if (voiceClass.file) {
      formData.append('thumbnail', voiceClass.file);
    }
    return formData;
  };

  const createVoiceClass = async (voiceClass: IVoiceClassDto): Promise<void> => {
    loading.value = true;
    error.value = null;

    try {
      const formData = convertToFormData(voiceClass);
      await voiceClassService.createVoiceClass(formData);
    } catch (e) {
      error.value = e;
      throw e;
    } finally {
      loading.value = false;
    }
  };

  const updateVoiceClass = async (id: number, voiceClass: IVoiceClassDto): Promise<void> => {
    loading.value = true;
    error.value = null;

    try {
      const formData = convertToFormData(voiceClass);
      await voiceClassService.updateVoiceClass(id, formData);
    } catch (e) {
      error.value = e;
      throw e;
    } finally {
      loading.value = false;
    }
  };

  return {
    voiceClasses,
    total,
    loading,
    error,
    fetchVoiceClasses,
    createVoiceClass,
    updateVoiceClass,
    convertToFormData,
  };
}
